import axios from 'axios';
import config from '../config';

// Configurar la URL base
axios.defaults.baseURL = config.apiUrl;

// Agregar interceptor para incluir el token en todas las peticiones
axios.interceptors.request.use(
  (configAxios) => {
    const token = localStorage.getItem(config.tokenKey);
    if (token) {
      configAxios.headers.Authorization = `Bearer ${token}`;
    }
    return configAxios;
  },
  (error) => Promise.reject(error)
);

// Interceptor para manejar errores 401 y 403
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 || error.response?.status === 403) {
      console.warn('🔐 Token inválido o expirado. Limpiando sesión...');
      localStorage.removeItem(config.tokenKey);
      localStorage.removeItem(config.userKey);
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

export default axios;
